import { Injectable } from "@angular/core";
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { Observable, of, EMPTY } from "rxjs";
import { mergeMap, take } from "rxjs/operators";

import { DataService } from "../services/data/data.service";
import { NotificationConfigModel } from "src/app/models/notification.model";


@Injectable({
  providedIn: "root"
})
export class UserNotificationsResolverService implements Resolve<NotificationConfigModel> {
  constructor(private dataService: DataService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<NotificationConfigModel> | Observable<never> {
    const uid = route.paramMap.get("profileId");
    return this.dataService.getUserNotifications(uid).pipe(
      take(1),
      mergeMap(item => {
        if (item) {
          return of(item);
        } else {
          // id not found
          return EMPTY;
        }
      })
    );
  }
}
